var _style, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRegisterLoadingIcon = function SvgRegisterLoadingIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes kf_dot15_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  13.75% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  23.13% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  32.5% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot15 {\n  animation: kf_dot15_opacity_0 1.6s linear infinite;\n}\n@keyframes kf_dot14_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  21.25% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  30.63% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  40% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot14 {\n  animation: kf_dot14_opacity_0 1.6s linear infinite;\n}\n@keyframes kf_dot12_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  13.75% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  23.13% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  32.5% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot12 {\n  animation: kf_dot12_opacity_0 1.6s linear infinite;\n}\n@keyframes kf_dot11_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  21.25% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  30.63% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  40% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot11 {\n  animation: kf_dot11_opacity_0 1.6s linear infinite;\n}\n@keyframes kf_dot10_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  28.75% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  38.13% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  47.5% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot10 {\n  animation: kf_dot10_opacity_0 1.6s linear infinite;\n}\n@keyframes kf_dot09_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  36.25% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  45.63% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  55% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot09 {\n  animation: kf_dot09_opacity_0 1.6s linear infinite;\n}\n@keyframes kf_dot08_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  21.25% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  30.63% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  40% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot08 {\n  animation: kf_dot08_opacity_0 1.6s linear infinite;\n}\n@keyframes kf_dot07_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  28.75% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  38.13% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  47.5% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot07 {\n  animation: kf_dot07_opacity_0 1.6s linear infinite;\n}\n@keyframes kf_dot06_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  36.25% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  45.63% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  55% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot06 {\n  animation: kf_dot06_opacity_0 1.6s linear infinite;\n}\n@keyframes kf_dot05_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  43.75% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  53.13% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  62.5% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot05 {\n  animation: kf_dot05_opacity_0 1.6s linear infinite;\n}\n@keyframes kf_dot03_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  36.25% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  45.63% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  55% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot03 {\n  animation: kf_dot03_opacity_0 1.6s linear infinite;\n}\n@keyframes kf_dot02_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  43.75% {\n    animation-timing-function: ease-out;\n    opacity: 0.15;\n  }\n  53.13% {\n    animation-timing-function: ease-in;\n    opacity: 1;\n  }\n  62.5% {\n    animation-timing-function: linear;\n    opacity: 0.15;\n  }\n  100% {\n    opacity: 0.15;\n  }\n}\n#dot02 {\n  animation: kf_dot02_opacity_0 1.6s linear infinite;\n}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "processing",
    clipPath: "url(#clip0_1_371)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "dot15",
    opacity: 0.15,
    transform: "translate(1 7)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot14",
    opacity: 0.15,
    transform: "translate(1 13)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot12",
    opacity: 0.15,
    transform: "translate(7 1)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot11",
    opacity: 0.15,
    transform: "translate(7 7)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot10",
    opacity: 0.15,
    transform: "translate(7 13)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot09",
    opacity: 0.15,
    transform: "translate(7 19)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot08",
    opacity: 0.15,
    transform: "translate(13 1)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot07",
    opacity: 0.15,
    transform: "translate(13 7)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot06",
    opacity: 0.15,
    transform: "translate(13 13)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot05",
    opacity: 0.15,
    transform: "translate(13 19)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot03",
    opacity: 0.15,
    transform: "translate(19 7)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot02",
    opacity: 0.15,
    transform: "translate(19 13)",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#003CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRegisterLoadingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "registerLoadingIcon.64c3aabcc445980e2cbdee47864dc889.svg";